var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-between-start flex-column md:flex-row" },
    [
      _c("div", { staticClass: "w-full md:w-1/2" }, [
        _c(
          "div",
          { staticClass: "color-grey1 fsize-16 text-bold text-uppercase" },
          [_vm._v("Etablissement")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.shop.FormeJuridique) +
              " " +
              _vm._s(_vm.shop.Enseigne) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--phone mb-5" }, [
          _vm._v("\n            Tel: "),
          _c("a", { attrs: { href: "tel:" + _vm.shop.Tel } }, [
            _vm._v(_vm._s(_vm.shop.Tel)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _c("span", [_vm._v("Adresse:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.shop.Adresse))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--city mb-5" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.shop.CodePostal) +
              " " +
              _vm._s(_vm.shop.Ville) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _vm._v(
            "\n            Email: " + _vm._s(_vm.shop.Email) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _vm._v(
            "\n            Siret: " + _vm._s(_vm.shop.Siret) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "shop-details--address mb-5" }, [
          _vm._v(
            "\n            TVA: " +
              _vm._s(_vm.shop.TvaIntracom) +
              " - Naf: " +
              _vm._s(_vm.shop.CodeNaf) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.client
        ? _c(
            "div",
            { staticClass: "w-full mt-20 md:w-1/2 mb-5 md:text-right md:mt-0" },
            [
              _vm.client
                ? _c(
                    "div",
                    {
                      staticClass:
                        "color-grey1 fsize-16 text-bold text-uppercase",
                    },
                    [_vm._v("Client")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "shop-details--address mb-5" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.client.Nom) +
                    " " +
                    _vm._s(_vm.client.Prenom) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _vm.client.Tel
                ? _c("div", { staticClass: "shop-details--phone mb-5" }, [
                    _vm._v("\n            Tel: "),
                    _c("a", { attrs: { href: "tel:" + _vm.client.Tel } }, [
                      _vm._v(_vm._s(_vm.client.Tel)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.client.Mobile
                ? _c("div", { staticClass: "shop-details--phone mb-5" }, [
                    _vm._v("\n            Mobile: "),
                    _c("a", { attrs: { href: "tel:" + _vm.client.Mobile } }, [
                      _vm._v(_vm._s(_vm.client.Mobile)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.client.Adresse
                ? _c("div", { staticClass: "shop-details--address mb-5" }, [
                    _vm._v(
                      "\n            Adresse: " +
                        _vm._s(_vm.client.Adresse) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.client.CodePostal || _vm.client.Ville
                ? _c("div", { staticClass: "shop-details--city mb-5" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.client.CodePostal) +
                        " " +
                        _vm._s(_vm.client.Ville) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.client.Email
                ? _c("div", { staticClass: "shop-details--address mb-5" }, [
                    _vm._v(
                      "\n            Email: " +
                        _vm._s(_vm.client.Email) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }